import { Information } from './Information'
import { withInformation } from './withInformation'

const ConnectedInformation = withInformation(Information)

export { ConnectedInformation as Information }
